import script from "./CheckboxGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts&setup=true"

import "./CheckboxGroup.vue?vue&type=style&index=0&id=25bb6d3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25bb6d3c"]])

export default __exports__